// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ownerList{overflow:initial!important}.no-class-container{width:100%;height:100px;display:flex;flex-flow:row;justify-content:space-around;align-items:center;padding:0 36px}.notOwner{background:#fff;font-size:16px;color:rgba(0,0,0,.64)}.padding-left{padding-left:18px}.actionSelect{max-width:55%!important}.ownerCard{max-height:350px;overflow-y:auto}.emailInput{width:100%}.mainShareCard{min-height:300px;background-color:#fff;overflow:auto}", ""]);
// Exports
module.exports = exports;
